import React from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.scss';

const LANGUAGES = [
    { code: 'kk', label: 'ҚАЗ' },
    { code: 'ru', label: 'РУС' },
    { code: 'en', label: 'ENG' },
];

/**
 * Language switcher component.
 * @param {'light'|'dark'} variant - 'dark' for dark backgrounds (TV, kiosk), 'light' for light backgrounds (cabinets)
 */
function LanguageSwitcher({ variant = 'light' }) {
    const { i18n } = useTranslation();
    const currentLang = i18n.language?.split('-')[0] || 'ru';

    const handleChange = (code) => {
        if (code !== currentLang) {
            i18n.changeLanguage(code);
        }
    };

    return (
        <div className={`lang-switcher lang-switcher--${variant}`}>
            {LANGUAGES.map((lang) => (
                <button
                    key={lang.code}
                    className={`lang-switcher__btn${currentLang === lang.code ? ' lang-switcher__btn--active' : ''}`}
                    onClick={() => handleChange(lang.code)}
                    type='button'
                >
                    {lang.label}
                </button>
            ))}
        </div>
    );
}

export default LanguageSwitcher;
